<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :title="dialogTitle"
      width="760px"
      top="8vh"
      append-to-body
      custom-class="recruit-share-dialog"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <div v-loading="loading" class="share-detail-wrap">
        <div class="summary-card">
          <div>
            <div class="summary-label">分享人数</div>
            <div class="summary-value">{{ shareTotal }}</div>
          </div>
          <div>
            <div class="summary-label">扫码报名人数</div>
            <div class="summary-value">{{ totalApplyCount }}</div>
          </div>
          <div>
            <div class="summary-label">当前岗位</div>
            <div class="summary-post">{{ postName || "—" }}</div>
          </div>
        </div>

        <el-table
          :data="shareRows"
          class="share-table"
          :header-cell-style="tableHeaderStyle"
          empty-text="暂无分享数据"
        >
          <el-table-column
            prop="share_user_name"
            label="分享人"
            align="center"
            min-width="120"
          />
          <el-table-column
            prop="share_user_phone"
            label="联系方式"
            align="center"
            min-width="140"
          />
          <el-table-column
            prop="share_time"
            label="分享时间"
            align="center"
            min-width="160"
          />
          <el-table-column
            prop="apply_count"
            label="扫码报名人数"
            align="center"
            min-width="120"
          />
          <el-table-column label="操作" align="center" width="110">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="link-button"
                @click="openApplicantDialog(scope.row)"
              >
                查看名单
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          v-if="sharePaging.total > 0"
          class="share-pagination"
          background
          small
          :current-page.sync="sharePaging.current_page"
          :page-size="sharePaging.page_size"
          :total="sharePaging.total"
          layout="total, prev, pager, next"
          @current-change="handleSharePageChange"
        />
      </div>
    </el-dialog>

    <RecruitShareApplicantDialog ref="recruitShareApplicantDialog" />
  </div>
</template>

<script>
import RecruitShareApplicantDialog from "@/components/RecruitShareApplicantDialog.vue";

const getFirstValue = (row, keys, fallback = "") => {
  for (let i = 0; i < keys.length; i += 1) {
    const value = row && row[keys[i]];
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }
  return fallback;
};

const normalizeList = (response) => {
  if (Array.isArray(response)) return response;
  const source =
    response && response.data && !Array.isArray(response.data)
      ? response.data
      : response;
  if (!source) return [];
  if (Array.isArray(source)) return source;
  if (Array.isArray(source.data)) return source.data;
  if (Array.isArray(source.list)) return source.list;
  if (Array.isArray(source.records)) return source.records;
  if (Array.isArray(source.rows)) return source.rows;
  return [];
};

const normalizePages = (response, fallback) => {
  const source =
    response && response.data && !Array.isArray(response.data)
      ? response.data
      : response;
  const pages = source && source.pages ? source.pages : {};
  return {
    current_page: Number(pages.current_page || fallback.current_page || 1),
    page_size: Number(pages.page_size || fallback.page_size || 10),
    total: Number(pages.total || 0),
  };
};

const toNumber = (value) => {
  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? 0 : numberValue;
};

export default {
  name: "RecruitShareDetailDialog",
  components: {
    RecruitShareApplicantDialog,
  },
  data() {
    return {
      visible: false,
      loading: false,
      currentPost: {},
      shareRows: [],
      sharePaging: {
        current_page: 1,
        page_size: 10,
        total: 0,
      },
      tableHeaderStyle: {
        background: "#f8fafc",
        color: "#4b5563",
        fontWeight: 600,
      },
    };
  },
  computed: {
    postName() {
      return this.currentPost.recruit_post || this.currentPost.name || "";
    },
    dialogTitle() {
      return `岗位分享详情：${this.postName || "岗位名称"}`;
    },
    totalApplyCount() {
      return this.shareRows.reduce((total, row) => {
        return total + Number(row.apply_count || 0);
      }, 0);
    },
    shareTotal() {
      return this.sharePaging.total || this.shareRows.length;
    },
  },
  methods: {
    async open(row) {
      if (!row || !row.id) {
        this.$message.warning("未获取到岗位信息");
        return;
      }
      this.visible = true;
      this.loading = true;
      this.currentPost = row;
      this.shareRows = [];
      this.sharePaging.current_page = 1;
      this.sharePaging.total = 0;
      await this.loadShareRows();
    },
    async loadShareRows() {
      if (!this.currentPost.id) return;
      this.loading = true;
      try {
        const response = await this.$api.recruitTaskShareList({
          task_id: this.currentPost.id,
          current_page: this.sharePaging.current_page,
          page_size: this.sharePaging.page_size,
        });
        this.shareRows = normalizeList(response).map(this.normalizeShareRow);
        this.sharePaging = normalizePages(response, this.sharePaging);
      } catch (error) {
        this.$message.error("获取分享详情失败");
      } finally {
        this.loading = false;
      }
    },
    normalizeShareRow(row, index) {
      const applicants = getFirstValue(
        row,
        ["applicants", "apply_list", "join_list", "users", "list"],
        []
      );
      return {
        ...row,
        row_key:
          getFirstValue(row, ["id", "share_id", "user_id", "share_user_id"]) ||
          index,
        task_share_id: getFirstValue(row, ["id", "task_share_id", "share_id"]),
        share_user_name: getFirstValue(row, [
          "share_user_name",
          "share_name",
          "name",
          "user_name",
          "fullName",
          "nickname",
        ], "—"),
        share_user_phone: getFirstValue(row, [
          "share_user_phone",
          "share_phone",
          "phone",
          "mobile",
          "tel",
          "contact",
        ], "—"),
        share_time: getFirstValue(row, [
          "share_time",
          "shared_at",
          "created_at",
          "create_time",
          "time",
        ], "—"),
        apply_count: toNumber(
          getFirstValue(row, [
            "apply_count",
            "join_count",
            "signup_count",
            "scan_apply_count",
            "person_num",
            "apply_num",
            "count",
          ], Array.isArray(applicants) ? applicants.length : 0)
        ),
        applicants: Array.isArray(applicants) ? applicants : [],
      };
    },
    openApplicantDialog(row) {
      this.$refs.recruitShareApplicantDialog.open({
        post: this.currentPost,
        share: row,
      });
    },
    handleSharePageChange(page) {
      this.sharePaging.current_page = page;
      this.loadShareRows();
    },
    handleClose() {
      this.loading = false;
      this.currentPost = {};
      this.shareRows = [];
      this.sharePaging = {
        current_page: 1,
        page_size: 10,
        total: 0,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .recruit-share-dialog {
  border-radius: 20px;
  overflow: hidden;
}

/deep/ .recruit-share-dialog .el-dialog__header {
  padding: 24px 28px 12px;
}

/deep/ .recruit-share-dialog .el-dialog__title {
  color: #1f2937;
  font-size: 20px;
  font-weight: 700;
}

/deep/ .recruit-share-dialog .el-dialog__body {
  padding: 0 28px 28px;
}

.share-detail-wrap {
  min-height: 260px;
}

.summary-card {
  display: grid;
  grid-template-columns: 150px 170px 1fr;
  gap: 14px;
  margin-bottom: 18px;
  padding: 18px;
  border: 1px solid #e8eef7;
  border-radius: 16px;
  background: linear-gradient(135deg, #f7fbff 0%, #ffffff 58%, #f8fbff 100%);
  box-shadow: 0 10px 28px rgba(31, 62, 104, 0.08);
}

.summary-label {
  margin-bottom: 8px;
  color: #6b7280;
  font-size: 13px;
}

.summary-value {
  color: #1677ff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
}

.summary-post {
  color: #111827;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  word-break: break-all;
}

.share-table {
  border: 1px solid #edf1f7;
  border-radius: 14px;
  overflow: hidden;
}

.share-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.link-button {
  color: #1684fc;
  font-weight: 600;
}

/deep/ .share-table .el-table__row {
  height: 54px;
}
</style>
